import moment from "moment";
import { Carrier } from "./Carrier";

export interface KpiShipmentPerformance {
  type: string | Carrier;
  average: number;
  partial: number;
  total: number;
}

export interface KpiShipmentPerformanceFilter {
  start: string;
  end: string;
  carriers?: string[];
}

export const defaultKpiShipmentPerformanceFilter: KpiShipmentPerformanceFilter =
  {
    start: moment().subtract(1, "months").startOf("day").toString(),
    end: moment().endOf("day").toString(),
  };
